// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-section-wrap.sidebar-close {
  padding-left: 66px;
}

.sidebar-wrap.sidebar-close .sidebar-balance-wrap {
  display: none;
}
.sidebar-wrap.sidebar-close .sidevar-menu-heading {
  visibility: hidden;
}
.sidebar-wrap.sidebar-close .sidevar-menu-heading:first-child {
  display: none;
}
.sidebar-wrap.sidebar-close .sidebar-menu-list {
  padding: 0 0.75rem;
}
.sidebar-wrap.sidebar-close .sidebar-menu-list p,
.sidebar-wrap.sidebar-close .sidebar-menu-list .menu-arrow {
  display: none;
}
.sidebar-wrap.sidebar-close .sidebar-menu-list li a {
  padding: 0.625rem 0.313rem;
}
@media screen and (max-width: 1024.98px) {
  .sidebar-wrap.sidebar-close .sidebar-menu-list li a {
    padding: 0.65rem;
  }
}
.sidebar-wrap.sidebar-close .sidebar-menu-list li a.active, .sidebar-wrap.sidebar-close .sidebar-menu-list li a:hover {
  background: transparent;
  border-color: transparent;
}
.sidebar-wrap.sidebar-close .sidebar-bottom-title {
  display: none;
}
@media screen and (max-width: 1400px) {
  .sidebar-wrap.sidebar-close .after-login-sidebar-content {
    display: none !important;
  }
}

.sidebar-content-wrap {
  max-height: calc(100vh - 4.25rem);
  overflow-y: auto;
  overflow-x: hidden;
}
@media screen and (max-width: 1199.98px) {
  .sidebar-content-wrap {
    padding-bottom: 4.75rem;
  }
}

.sidebar-balance-wrap {
  padding: 1rem 1rem;
  display: flex;
}
.sidebar-balance-wrap h4 {
  color: var(--white);
  font-weight: 600;
  font-size: 1rem;
}
.sidebar-balance-wrap h4 span {
  color: var(--authSocailTextColor);
}
.sidebar-balance-wrap p {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--authSocailTextColor);
  display: flex;
  align-items: center;
  margin: 0;
}
.sidebar-balance-wrap p span {
  padding-left: 0.313rem;
}
.sidebar-balance-wrap p span.text-red {
  color: var(--loss);
}
.sidebar-balance-wrap p span.text-green {
  color: var(--green);
}
.sidebar-balance-wrap .currency-icon {
  height: 24px;
  width: 24px;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  margin-right: 0.625rem;
}
.sidebar-balance-wrap .currency-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sidebar-wrap {
  font-weight: 800;
  width: 250px;
  position: fixed;
  top: 75px;
  height: 100vh;
}

.sidebar-wrap.sidebar-close .sidebar-top-cta {
  display: none;
}

.sidebar-wrap.sidebar-close .sidebar-listing-wrap li a {
  padding: 10px 0;
  justify-content: center;
}

.sidebar-wrap.sidebar-close .sidebar-listing-wrap li {
  padding: 10px 0;
}

.sidebar-wrap.sidebar-close {
  width: 0;
}
@media screen and (min-width: 1025px) {
  .sidebar-wrap.sidebar-close {
    /* transform: translate(-180px); */
    width: 52px;
  }
}

.sidebar-wrap.sidebar-close .favourite-btn a {
  padding-left: 10px;
}

.sidebar-wrap .favourite-btn {
  border: 0.900033px solid var(--gray);
  border-width: 1px 0;
  padding: 10px 5px;
  margin: 30px 20px 20px;
}
.sidebar-wrap.sidebar-close .favourite-btn {
  margin: 30px 6px 20px;
}

.favourite-btn a span {
  padding-left: 16px;
}

.sidebar-wrap.sidebar-close .language-select-wrap select,
.sidebar-wrap.sidebar-close .theme-switcher-wrap .toggle-slot {
  background: transparent;
  border: transparent;
}

.sidebar-wrap.sidebar-close .language-select-wrap img {
  left: -3px;
}

.sidebar-wrap.sidebar-close .sidebar-listing-wrap li a span,
.sidebar-wrap.sidebar-close .favourite-btn a span,
.sidebar-wrap.sidebar-close .language-wrap span,
.sidebar-wrap.sidebar-close .theme-label,
.sidebar-wrap.sidebar-close .theme-switcher-wrap .toggle-slot:after,
.sidebar-wrap.sidebar-close .sidebar-ad-section {
  display: none;
}

.sidebar-wrap.sidebar-close .sidebar-listing-wrap li:hover a,
.sidebar-wrap.sidebar-close .sidebar-listing-wrap li.active a {
  background: transparent;
}

.sidebar-wrap .sports-btn {
  height: 30px;
  width: 30px;
  border-radius: 100%;
  background: var(--cinder);
  display: flex;
  align-items: center;
  justify-content: center;
}

.sports-listing {
  padding: 20px;
}

.sidebar-wrap .sports-btn img:nth-child(2),
.sidebar-wrap .sports-btn:hover img:nth-child(1),
.sidebar-wrap .sports-btn.active img:nth-child(1) {
  display: none;
}

.sidebar-wrap .sports-btn:hover img:nth-child(2),
.sidebar-wrap .sports-btn.active img:nth-child(2) {
  display: block;
}

.sidebar-wrap .sports-btn:hover,
.sidebar-wrap .sports-btn.active {
  background: var(--aquaBlue);
}

.sidebar-listing-wrap {
  padding: 20px 5px 0;
}

.sidebar-listing-wrap li {
  margin-bottom: 5px;
}

.sidebar-listing-wrap li a,
.favourite-btn a {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  position: relative;
  color: var(--white);
  border-radius: 30px;
  font-weight: 700;
  font-size: 16px;
}

.favourite-btn a {
  padding: 12px 5px;
}

.sidebar-listing-wrap li a span {
  padding-left: 35px;
  white-space: nowrap;
}

.sidebar-listing-wrap li a img {
  position: absolute;
}

.sidebar-listing-wrap .sidebar-submenu li img {
  width: 18px;
  height: 18px;
}

.sidebar-listing-wrap li:hover > a,
.sidebar-listing-wrap li.active > a {
  background: var(--lightSlate);
  color: var(--white);
}

.sidebar-listing-wrap li:hover a svg {
  fill: var(--aquaBlue);
}

.sidebar-listing-wrap li a img:nth-child(2) {
  display: none;
}

.sidebar-listing-wrap li:hover > a img:nth-child(2),
.sidebar-listing-wrap li.active > a img:nth-child(2) {
  display: block;
  filter: brightness(0) saturate(100%) invert(32%) sepia(96%) saturate(1267%) hue-rotate(173deg) brightness(95%) contrast(98%);
}

.sidebar-wrap .accordion-body {
  padding: 10px;
}

.sidebar-toggle-btn {
  background: var(--primaryBtnBorder);
  height: 1.375rem;
  width: 1.375rem;
  flex: 0 0 1.375rem;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  transition: all 200ms ease-in-out;
  border: 1px solid var(--secondry-border);
  box-shadow: 0px 0px 4px var(--secondaryBtnBorder);
}
.sidebar-toggle-btn img {
  transition: all 200ms ease-in-out;
}
.sidebar-toggle-btn i {
  font-size: 0.8rem;
}

.sidebar-wrap.sidebar-close .sidebar-toggle-btn img {
  transform: rotate(180deg);
}

.sidebar-wrap.sidebar-close .sidebar-listing-wrap {
  padding-top: 50px;
}

.sidebar-wrap {
  z-index: 10;
  border-right: 1px solid var(--sidebarTooltip);
  background-color: var(--theme-dark);
  display: flex;
}
.sidebar-wrap .sidebar-toggle-btn {
  position: absolute;
  left: auto;
  top: 76px;
  right: -10px;
  z-index: 3;
}
@media screen and (max-width: 1024.98px) {
  .sidebar-wrap .sidebar-toggle-btn {
    right: 0;
    top: 6px;
  }
}
.sidebar-wrap.sidebar-close .sidebar-toggle-btn {
  right: 0;
  left: -30px;
  padding: 0;
}
@media screen and (max-width: 767.98px) {
  .sidebar-wrap.sidebar-close .sidebar-toggle-btn {
    left: -40px;
  }
}
@media screen and (min-width: 1025px) {
  .sidebar-wrap.sidebar-close .sidebar-toggle-btn {
    left: 10px;
    top: 20px;
    transform: rotate(180deg);
  }
}
.sidebar-wrap.sidebar-close .sidebar-toggle-btn img {
  transform: rotate(180deg);
}
.sidebar-wrap.sidebar-close .sidebar-listing-wrap {
  padding-top: 50px;
}
.sidebar-wrap .sidebar-menu-list {
  margin: 0.625rem 0;
  padding: 0 1rem;
}
.sidebar-wrap .sidebar-menu-list h4 {
  color: var(--authSocailTextColor);
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.625rem;
  text-transform: uppercase;
}
.sidebar-wrap .sidebar-menu-list li {
  margin-bottom: 0.1rem;
}
.sidebar-wrap .sidebar-menu-list li > a {
  padding: 0.68rem;
  color: var(--white);
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  transition: all 0.2s ease 0s;
  position: relative;
  min-width: 208px;
}
.sidebar-wrap .sidebar-menu-list li > a.active p {
  color: var(--white);
}
.sidebar-wrap .sidebar-menu-list li > a p {
  font-weight: 500;
  max-width: 120px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.9375rem;
  color: var(--balck);
}
.sidebar-wrap .sidebar-menu-list li > a:hover, .sidebar-wrap .sidebar-menu-list li > a.active {
  background: var(--secondaryRadialBtn);
  color: var(--balck);
}
.sidebar-wrap .sidebar-menu-list li > a:hover .menu-arrow, .sidebar-wrap .sidebar-menu-list li > a.active .menu-arrow {
  background: var(--white-015);
}
.sidebar-wrap .sidebar-menu-list li > a:hover .menu-arrow i, .sidebar-wrap .sidebar-menu-list li > a.active .menu-arrow i {
  color: var(--white);
}
.sidebar-wrap .sidebar-menu-list li > a:hover svg, .sidebar-wrap .sidebar-menu-list li > a:hover img, .sidebar-wrap .sidebar-menu-list li > a.active svg, .sidebar-wrap .sidebar-menu-list li > a.active img {
  color: var(--black);
  fill: var(--black);
}
.sidebar-wrap .sidebar-menu-list li > a:hover svg path, .sidebar-wrap .sidebar-menu-list li > a.active svg path {
  color: var(--black);
  fill: var(--black);
}
.sidebar-wrap .sidebar-menu-list li > a:hover img.crypto-img, .sidebar-wrap .sidebar-menu-list li > a.active img.crypto-img {
  filter: none;
}
.sidebar-wrap .sidebar-menu-list li > a.active i {
  color: var(--white);
}
.sidebar-wrap .sidebar-menu-list li > a.crypto-list svg {
  filter: unset;
}
.sidebar-wrap .sidebar-menu-list li .menu-arrow {
  padding: 0.02rem 0.325rem;
  border-radius: 0.375rem;
  text-align: center;
  background: var(--sidebarTooltip);
  color: var(--authSocailTextColor);
  position: absolute;
  right: 0.5rem;
  width: 20px;
  height: 20px;
}
.sidebar-wrap .sidebar-menu-list li .menu-arrow i {
  color: var(--authTabBtnText);
}
.sidebar-wrap .sidebar-menu-list .menu-icon {
  margin-right: 0.625rem;
}
.sidebar-wrap .sidebar-menu-list .menu-icon svg {
  width: 1.1rem;
  height: 1.1rem;
}
.sidebar-wrap .sidebar-menu-list .crypto-cont a {
  padding: 5px;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap {
  border-radius: 0;
  padding: 0;
  animation: 400ms ease-in-out 0s 1 normal none running accordianEffect;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap li > a {
  color: var(--authSocailTextColor);
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap li > a img {
  margin-right: 0.625rem;
  width: 1.125rem;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap li > a svg {
  margin-right: 0.313rem;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap li > a:hover, .sidebar-wrap .sidebar-menu-list .submenu-wrap li > a.active {
  color: var(--white);
  background: transparent;
  border-color: transparent;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap li > a:hover img, .sidebar-wrap .sidebar-menu-list .submenu-wrap li > a.active img {
  filter: brightness(10);
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap li > a:hover svg, .sidebar-wrap .sidebar-menu-list .submenu-wrap li > a.active svg {
  fill: var(--white);
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap li > a:hover svg path, .sidebar-wrap .sidebar-menu-list .submenu-wrap li > a.active svg path {
  fill: var(--white);
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list-wrap .crypto-list-right {
  position: relative;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list-wrap .crypto-list-right svg,
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list-wrap .crypto-list-right img {
  margin-right: 0;
  margin-left: 0;
  position: absolute;
  right: -0.625rem;
  top: 0;
  width: 1rem;
  height: 1rem;
  margin-right: 0;
  filter: unset;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list-wrap .crypto-list-right span {
  margin-right: 0.313rem;
  color: var(--white);
  font-size: 0.75rem;
  font-weight: 500;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list-wrap .crypto-list {
  width: 100%;
  min-width: auto;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list-wrap .crypto-list .crypto-list-left svg,
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list-wrap .crypto-list .crypto-list-left img {
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 100%;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list-wrap .crypto-list:hover svg {
  filter: unset;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list .crypto-list-right {
  position: relative;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list .crypto-list-right svg,
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list .crypto-list-right img {
  margin-right: 0;
  margin-left: 0;
  position: absolute;
  right: -0.625rem;
  top: 0;
  width: 1rem;
  height: 1rem;
  margin-right: 0.313rem;
  filter: unset;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list .crypto-list-right span {
  margin-right: 10px;
  color: var(--white);
  font-size: 0.75rem;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list .crypto-list-left svg,
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list .crypto-list-left img {
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 100%;
}
.sidebar-wrap .sidebar-menu-list .submenu-wrap .crypto-list:hover svg {
  filter: unset;
}

.sidebar-top-cta {
  background: var(--primaryDark);
  padding: 10px;
  justify-content: space-between;
  box-shadow: 0px 4px 4px var(--blackOpacity50);
  width: 100%;
  min-height: 48px;
  align-items: center;
}
.sidebar-top-cta .nav-link img {
  max-width: 25px;
  padding-left: 0 !important;
}

.nav-link.cta-btn {
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 30px;
  color: var(--white);
  width: 100%;
  white-space: nowrap;
}

.sidebar-top-cta-wrap {
  padding: 10px 5px 0;
}

.advertisement-card {
  height: 180px;
  border-radius: 18px;
  overflow: hidden;
}

.advertisement-card img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.theme-label span,
.sidebar-ad-section p {
  font-size: 10px;
  color: var(--gray);
  line-height: 16px;
  font-weight: 400;
  display: block;
}

.sidebar-ad-section {
  padding: 20px;
}

.Mobile-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4.25rem;
  background-color: var(--theme-dark);
  z-index: 999;
  box-shadow: 0px 0px 4px var(--blackOpacity50);
}
.Mobile-bottom-bar .list-inline {
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
}
.Mobile-bottom-bar .list-inline .list-inline-item {
  flex: 1 0;
  margin-right: 0 !important;
  padding: 0.625rem 0.25rem;
  text-align: center;
}
.Mobile-bottom-bar .list-inline .list-inline-item span {
  font-size: 12px;
  color: var(--white);
  white-space: nowrap;
}
.Mobile-bottom-bar .list-inline .list-inline-item.active img {
  filter: brightness(0) saturate(100%) invert(21%) sepia(74%) saturate(2846%) hue-rotate(177deg) brightness(94%) contrast(99%);
}
.Mobile-bottom-bar .list-inline .list-inline-item.active span {
  color: var(--aquaBlue);
}
.Mobile-bottom-bar button {
  width: 3rem;
  min-width: 3rem;
  height: 3rem;
  background: var(--sidebarTooltip);
  position: relative;
  padding: 0.25rem;
}
.Mobile-bottom-bar button svg {
  filter: brightness(10);
  width: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/SideNavBar/sideNavBar.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAII;EACE,aAAA;AADN;AAII;EACE,kBAAA;AAFN;AAIM;EACE,aAAA;AAFR;AAMI;EACE,kBAAA;AAJN;AAMM;;EAEE,aAAA;AAJR;AAQQ;EACE,0BAAA;AANV;AAQU;EAHF;IAII,gBAAA;EALV;AACF;AAOU;EAEE,uBAAA;EACA,yBAAA;AANZ;AAcI;EACE,aAAA;AAZN;AAgBM;EADF;IAEI,wBAAA;EAbN;AACF;;AAkBA;EACE,iCAAA;EACA,gBAAA;EACA,kBAAA;AAfF;AAiBE;EALF;IAMI,uBAAA;EAdF;AACF;;AAsBA;EACE,kBAAA;EACA,aAAA;AAnBF;AAqBE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AAnBJ;AAqBI;EACE,iCAAA;AAnBN;AAuBE;EACE,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AArBJ;AAuBI;EACE,sBAAA;AArBN;AAuBM;EACE,kBAAA;AArBR;AAwBM;EACE,mBAAA;AAtBR;AA4BE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AA1BJ;AA4BI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA1BN;;AA+BA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;AA5BF;;AA+BA;EACE,aAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,uBAAA;AA5BF;;AA+BA;EACE,eAAA;AA5BF;;AA+BA;EACE,QAAA;AA5BF;AA8BE;EAHF;IAII,kCAAA;IACA,WAAA;EA3BF;AACF;;AA8BA;EACE,kBAAA;AA3BF;;AA+BE;EACE,oCAAA;EAEA,mBAAA;EACA,iBAAA;EACA,sBAAA;AA7BJ;AAiCI;EACE,qBAAA;AA/BN;;AAoCA;EACE,kBAAA;AAjCF;;AAoCA;;EAEE,uBAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,UAAA;AAjCF;;AAoCA;;;;;;EAME,aAAA;AAjCF;;AAoCA;;EAEE,uBAAA;AAjCF;;AAoCA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjCF;;AAoCA;EACE,aAAA;AAjCF;;AAoCA;;;EAGE,aAAA;AAjCF;;AAoCA;;EAEE,cAAA;AAjCF;;AAoCA;;EAEE,2BAAA;AAjCF;;AAoCA;EACE,mBAAA;AAjCF;;AAoCA;EACE,kBAAA;AAjCF;;AAoCA;;EAEE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAjCF;;AAoCA;EACE,iBAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,kBAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,YAAA;AAjCF;;AAoCA;;EAEE,6BAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,qBAAA;AAjCF;;AAoCA;EACE,aAAA;AAjCF;;AAoCA;;EAEE,cAAA;EACA,4HAAA;AAjCF;;AAoCA;EACE,aAAA;AAjCF;;AAoCA;EACE,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iCAAA;EACA,wCAAA;EACA,iDAAA;AAjCF;AAmCE;EACE,iCAAA;AAjCJ;AAoCE;EACE,iBAAA;AAlCJ;;AAsCA;EACE,yBAAA;AAnCF;;AAsCA;EACE,iBAAA;AAnCF;;AAsCA;EACE,WAAA;EAEA,6CAAA;EACA,mCAAA;EACA,aAAA;AApCF;AAsCE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AApCJ;AAsCI;EAPF;IAQI,QAAA;IACA,QAAA;EAnCJ;AACF;AAuCI;EACE,QAAA;EACA,WAAA;EACA,UAAA;AArCN;AAuCM;EALF;IAMI,WAAA;EApCN;AACF;AAsCM;EATF;IAUI,UAAA;IACA,SAAA;IACA,yBAAA;EAnCN;AACF;AAsCI;EACE,yBAAA;AApCN;AAuCI;EACE,iBAAA;AArCN;AAyCE;EACE,kBAAA;EACA,eAAA;AAvCJ;AAyCI;EACE,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;AAvCN;AA0CI;EACE,qBAAA;AAxCN;AA0CM;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EAEA,qBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AAzCR;AA4CU;EAGE,mBAAA;AA5CZ;AAiDQ;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;AA/CV;AAkDQ;EAEE,qCAAA;EACA,mBAAA;AAjDV;AAmDU;EACE,4BAAA;AAjDZ;AAmDY;EACE,mBAAA;AAjDd;AAqDU;EAEE,mBAAA;EACA,kBAAA;AApDZ;AAwDY;EACE,mBAAA;EACA,kBAAA;AAtDd;AA0DU;EACE,YAAA;AAxDZ;AA6DU;EACE,mBAAA;AA3DZ;AAiEU;EACE,aAAA;AA/DZ;AAqEM;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iCAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AAnER;AAqEQ;EACE,4BAAA;AAnEV;AAwEI;EACE,sBAAA;AAtEN;AAwEM;EACE,aAAA;EACA,cAAA;AAtER;AA0EI;EACE,YAAA;AAxEN;AA2EI;EACE,gBAAA;EACA,UAAA;EACA,qEAAA;AAzEN;AA2EM;EAEE,iCAAA;AA1ER;AA4EQ;EACE,sBAAA;EACA,eAAA;AA1EV;AA6EQ;EACE,sBAAA;AA3EV;AA8EQ;EAEE,mBAAA;EACA,uBAAA;EACA,yBAAA;AA7EV;AA+EU;EACE,sBAAA;AA7EZ;AAgFU;EACE,kBAAA;AA9EZ;AAgFY;EACE,kBAAA;AA9Ed;AAoFM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAlFR;AAoFQ;EACE,kBAAA;AAlFV;AAoFU;;EAEE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAlFZ;AAqFU;EACE,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAnFZ;AAuFQ;EACE,WAAA;EACA,eAAA;AArFV;AAyFY;;EAEE,cAAA;EACA,aAAA;EACA,mBAAA;AAvFd;AA4FY;EACE,aAAA;AA1Fd;AAiGQ;EACE,kBAAA;AA/FV;AAiGU;;EAEE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;AA/FZ;AAkGU;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AAhGZ;AAsGU;;EAEE,cAAA;EACA,aAAA;EACA,mBAAA;AApGZ;AAyGU;EACE,aAAA;AAvGZ;;AA+GA;EACE,8BAAA;EACA,aAAA;EACA,8BAAA;EACA,6CAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AA5GF;AA+GI;EACE,eAAA;EACA,0BAAA;AA7GN;;AAkHA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AA/GF;;AAkHA;EACE,mBAAA;AA/GF;;AAkHA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA/GF;;AAkHA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA/GF;;AAkHA;;EAEE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AA/GF;;AAkHA;EACE,aAAA;AA/GF;;AAmHA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,mCAAA;EACA,YAAA;EACA,6CAAA;AAhHF;AAkHE;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,yCAAA;AAhHJ;AAkHI;EACE,SAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;AAhHN;AAkHM;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;AAhHR;AAoHQ;EACE,4HAAA;AAlHV;AAqHQ;EACE,sBAAA;AAnHV;AAyHE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;AAvHJ;AAyHI;EACE,sBAAA;EACA,aAAA;AAvHN","sourcesContent":[".right-section-wrap.sidebar-close {\n  padding-left: 66px;\n}\n\n.sidebar-wrap {\n  &.sidebar-close {\n    .sidebar-balance-wrap {\n      display: none;\n    }\n\n    .sidevar-menu-heading {\n      visibility: hidden;\n\n      &:first-child {\n        display: none;\n      }\n    }\n\n    .sidebar-menu-list {\n      padding: 0 0.75rem;\n\n      p,\n      .menu-arrow {\n        display: none;\n      }\n\n      li {\n        a {\n          padding: 0.625rem 0.313rem;\n\n          @media screen and (max-width: 1024.98px) {\n            padding: 0.65rem;\n          }\n\n          &.active,\n          &:hover {\n            background: transparent;\n            border-color: transparent;\n\n          }\n\n        }\n      }\n    }\n\n    .sidebar-bottom-title {\n      display: none;\n    }\n\n    .after-login-sidebar-content {\n      @media screen and (max-width: 1400px) {\n        display: none !important;\n      }\n    }\n  }\n}\n\n.sidebar-content-wrap {\n  max-height: calc(100vh - 4.25rem);\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  @media screen and (max-width: 1199.98px) {\n    padding-bottom: 4.75rem;\n  }\n\n  // .rc-tooltip-content {\n  //   background: var(--sidebarTooltip);\n  //   border-radius: 0.313rem;\n  // }\n}\n\n.sidebar-balance-wrap {\n  padding: 1rem 1rem;\n  display: flex;\n\n  h4 {\n    color: var(--white);\n    font-weight: 600;\n    font-size: 1rem;\n\n    span {\n      color: var(--authSocailTextColor);\n    }\n  }\n\n  p {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: var(--authSocailTextColor);\n    display: flex;\n    align-items: center;\n    margin: 0;\n\n    span {\n      padding-left: 0.313rem;\n\n      &.text-red {\n        color: var(--loss);\n      }\n\n      &.text-green {\n        color: var(--green);\n      }\n    }\n\n  }\n\n  .currency-icon {\n    height: 24px;\n    width: 24px;\n    border-radius: 100%;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    margin-right: 0.625rem;\n\n    & img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n}\n\n.sidebar-wrap {\n  font-weight: 800;\n  width: 250px;\n  position: fixed;\n  top: 75px;\n  height: 100vh;\n}\n\n.sidebar-wrap.sidebar-close .sidebar-top-cta {\n  display: none;\n}\n\n.sidebar-wrap.sidebar-close .sidebar-listing-wrap li a {\n  padding: 10px 0;\n  justify-content: center;\n}\n\n.sidebar-wrap.sidebar-close .sidebar-listing-wrap li {\n  padding: 10px 0;\n}\n\n.sidebar-wrap.sidebar-close {\n  width: 0;\n\n  @media screen and (min-width: 1025px) {\n    /* transform: translate(-180px); */\n    width: 52px;\n  }\n}\n\n.sidebar-wrap.sidebar-close .favourite-btn a {\n  padding-left: 10px;\n}\n\n.sidebar-wrap {\n  .favourite-btn {\n    border: 0.900033px solid var(--gray);\n    ;\n    border-width: 1px 0;\n    padding: 10px 5px;\n    margin: 30px 20px 20px;\n  }\n\n  &.sidebar-close {\n    .favourite-btn {\n      margin: 30px 6px 20px;\n    }\n  }\n}\n\n.favourite-btn a span {\n  padding-left: 16px;\n}\n\n.sidebar-wrap.sidebar-close .language-select-wrap select,\n.sidebar-wrap.sidebar-close .theme-switcher-wrap .toggle-slot {\n  background: transparent;\n  border: transparent;\n}\n\n.sidebar-wrap.sidebar-close .language-select-wrap img {\n  left: -3px;\n}\n\n.sidebar-wrap.sidebar-close .sidebar-listing-wrap li a span,\n.sidebar-wrap.sidebar-close .favourite-btn a span,\n.sidebar-wrap.sidebar-close .language-wrap span,\n.sidebar-wrap.sidebar-close .theme-label,\n.sidebar-wrap.sidebar-close .theme-switcher-wrap .toggle-slot:after,\n.sidebar-wrap.sidebar-close .sidebar-ad-section {\n  display: none;\n}\n\n.sidebar-wrap.sidebar-close .sidebar-listing-wrap li:hover a,\n.sidebar-wrap.sidebar-close .sidebar-listing-wrap li.active a {\n  background: transparent;\n}\n\n.sidebar-wrap .sports-btn {\n  height: 30px;\n  width: 30px;\n  border-radius: 100%;\n  background: var(--cinder);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sports-listing {\n  padding: 20px;\n}\n\n.sidebar-wrap .sports-btn img:nth-child(2),\n.sidebar-wrap .sports-btn:hover img:nth-child(1),\n.sidebar-wrap .sports-btn.active img:nth-child(1) {\n  display: none;\n}\n\n.sidebar-wrap .sports-btn:hover img:nth-child(2),\n.sidebar-wrap .sports-btn.active img:nth-child(2) {\n  display: block;\n}\n\n.sidebar-wrap .sports-btn:hover,\n.sidebar-wrap .sports-btn.active {\n  background: var(--aquaBlue);\n}\n\n.sidebar-listing-wrap {\n  padding: 20px 5px 0;\n}\n\n.sidebar-listing-wrap li {\n  margin-bottom: 5px;\n}\n\n.sidebar-listing-wrap li a,\n.favourite-btn a {\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  color: var(--white);\n  border-radius: 30px;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.favourite-btn a {\n  padding: 12px 5px;\n}\n\n.sidebar-listing-wrap li a span {\n  padding-left: 35px;\n  white-space: nowrap;\n}\n\n.sidebar-listing-wrap li a img {\n  position: absolute;\n}\n\n.sidebar-listing-wrap .sidebar-submenu li img {\n  width: 18px;\n  height: 18px;\n}\n\n.sidebar-listing-wrap li:hover > a,\n.sidebar-listing-wrap li.active > a {\n  background: var(--lightSlate);\n  color: var(--white);\n}\n\n.sidebar-listing-wrap li:hover a svg {\n  fill: var(--aquaBlue);\n}\n\n.sidebar-listing-wrap li a img:nth-child(2) {\n  display: none;\n}\n\n.sidebar-listing-wrap li:hover > a img:nth-child(2),\n.sidebar-listing-wrap li.active > a img:nth-child(2) {\n  display: block;\n  filter: brightness(0) saturate(100%) invert(32%) sepia(96%) saturate(1267%) hue-rotate(173deg) brightness(95%) contrast(98%);\n}\n\n.sidebar-wrap .accordion-body {\n  padding: 10px;\n}\n\n.sidebar-toggle-btn {\n  background: var(--primaryBtnBorder);\n  height: 1.375rem;\n  width: 1.375rem;\n  flex: 0 0 1.375rem;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  transition: all 200ms ease-in-out;\n  border: 1px solid var(--secondry-border);\n  box-shadow: 0px 0px 4px var(--secondaryBtnBorder);\n\n  img {\n    transition: all 200ms ease-in-out;\n  }\n\n  i {\n    font-size: 0.8rem;\n  }\n}\n\n.sidebar-wrap.sidebar-close .sidebar-toggle-btn img {\n  transform: rotate(180deg);\n}\n\n.sidebar-wrap.sidebar-close .sidebar-listing-wrap {\n  padding-top: 50px;\n}\n\n.sidebar-wrap {\n  z-index: 10;\n  // box-shadow: 1px 0 1px #0b1216;\n  border-right: 1px solid var(--sidebarTooltip);\n  background-color: var(--theme-dark);\n  display: flex;\n\n  .sidebar-toggle-btn {\n    position: absolute;\n    left: auto;\n    top: 76px;\n    right: -10px;\n    z-index: 3;\n\n    @media screen and (max-width: 1024.98px) {\n      right: 0;\n      top: 6px;\n    }\n  }\n\n  &.sidebar-close {\n    .sidebar-toggle-btn {\n      right: 0;\n      left: -30px;\n      padding: 0;\n\n      @media screen and (max-width: 767.98px) {\n        left: -40px;\n      }\n\n      @media screen and (min-width: 1025px) {\n        left: 10px;\n        top: 20px;\n        transform: rotate(180deg);\n      }\n    }\n\n    .sidebar-toggle-btn img {\n      transform: rotate(180deg);\n    }\n\n    .sidebar-listing-wrap {\n      padding-top: 50px;\n    }\n  }\n\n  .sidebar-menu-list {\n    margin: 0.625rem 0;\n    padding: 0 1rem;\n\n    h4 {\n      color: var(--authSocailTextColor);\n      font-size: 0.875rem;\n      font-weight: 500;\n      margin-bottom: 0.625rem;\n      text-transform: uppercase;\n    }\n\n    li {\n      margin-bottom: 0.1rem;\n\n      & > a {\n        padding: 0.68rem;\n        color: var(--white);\n        font-size: 0.875rem;\n        font-weight: 500;\n        display: flex;\n        align-items: center;\n        // justify-content: space-between;\n        border-radius: 0.5rem;\n        transition: all 0.2s ease 0s;\n        position: relative;\n        min-width: 208px;\n\n        &.active {\n          p {\n            // color: var( --headingLink);\n            // text-shadow: var(  --headingLink) 0px 0px 8px;\n            color: var(--white);\n          }\n\n        }\n\n        p {\n          font-weight: 500;\n          max-width: 120px;\n          overflow-x: hidden;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          font-size: 0.9375rem;\n          color: var(--balck);\n        }\n\n        &:hover,\n        &.active {\n          background: var(--secondaryRadialBtn);\n          color: var(--balck);\n\n          .menu-arrow {\n            background: var(--white-015);\n\n            i {\n              color: var(--white);\n            }\n          }\n\n          & svg,\n          & img {\n            color: var(--black);\n            fill: var(--black);\n          }\n\n          & svg {\n            path {\n              color: var(--black);\n              fill: var(--black);\n            }\n          }\n\n          & img.crypto-img {\n            filter: none;\n          }\n        }\n\n        &.active {\n          i {\n            color: var(--white);\n            // transform: rotate(180deg);\n          }\n        }\n\n        &.crypto-list {\n          & svg {\n            filter: unset;\n\n          }\n        }\n      }\n\n      .menu-arrow {\n        padding: 0.02rem 0.325rem;\n        border-radius: 0.375rem;\n        text-align: center;\n        background: var(--sidebarTooltip);\n        color: var(--authSocailTextColor);\n        position: absolute;\n        right: 0.5rem;\n        width: 20px;\n        height: 20px;\n\n        i {\n          color: var(--authTabBtnText)\n        }\n      }\n    }\n\n    .menu-icon {\n      margin-right: 0.625rem;\n\n      svg {\n        width: 1.1rem;\n        height: 1.1rem;\n      }\n    }\n\n    .crypto-cont a {\n      padding: 5px;\n    }\n\n    .submenu-wrap {\n      border-radius: 0;\n      padding: 0;\n      animation: 400ms ease-in-out 0s 1 normal none running accordianEffect;\n\n      li > a {\n        // justify-content: flex-start;\n        color: var(--authSocailTextColor);\n\n        & img {\n          margin-right: 0.625rem;\n          width: 1.125rem;\n        }\n\n        & svg {\n          margin-right: 0.313rem;\n        }\n\n        &:hover,\n        &.active {\n          color: var(--white);\n          background: transparent;\n          border-color: transparent;\n\n          & img {\n            filter: brightness(10);\n          }\n\n          & svg {\n            fill: var(--white);\n\n            path {\n              fill: var(--white);\n            }\n          }\n        }\n      }\n\n      .crypto-list-wrap {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        position: relative;\n\n        .crypto-list-right {\n          position: relative;\n\n          svg,\n          img {\n            margin-right: 0;\n            margin-left: 0;\n            position: absolute;\n            right: -0.625rem;\n            top: 0;\n            width: 1rem;\n            height: 1rem;\n            margin-right: 0;\n            filter: unset;\n          }\n\n          span {\n            margin-right: 0.313rem;\n            color: var(--white);\n            font-size: 0.75rem;\n            font-weight: 500;\n          }\n        }\n\n        .crypto-list {\n          width: 100%;\n          min-width: auto;\n\n          .crypto-list-left {\n\n            svg,\n            img {\n              height: 1.5rem;\n              width: 1.5rem;\n              border-radius: 100%;\n            }\n          }\n\n          &:hover {\n            svg {\n              filter: unset;\n            }\n          }\n        }\n      }\n\n      .crypto-list {\n        .crypto-list-right {\n          position: relative;\n\n          svg,\n          img {\n            margin-right: 0;\n            margin-left: 0;\n            position: absolute;\n            right: -0.625rem;\n            top: 0;\n            width: 1rem;\n            height: 1rem;\n            margin-right: 0.313rem;\n            filter: unset;\n          }\n\n          span {\n            margin-right: 10px;\n            color: var(--white);\n            font-size: 0.75rem;\n          }\n        }\n\n        .crypto-list-left {\n\n          svg,\n          img {\n            height: 1.5rem;\n            width: 1.5rem;\n            border-radius: 100%;\n          }\n        }\n\n        &:hover {\n          svg {\n            filter: unset;\n          }\n        }\n      }\n    }\n  }\n}\n\n.sidebar-top-cta {\n  background: var(--primaryDark);\n  padding: 10px;\n  justify-content: space-between;\n  box-shadow: 0px 4px 4px var(--blackOpacity50);\n  width: 100%;\n  min-height: 48px;\n  align-items: center;\n\n  .nav-link {\n    img {\n      max-width: 25px;\n      padding-left: 0 !important;\n    }\n  }\n}\n\n.nav-link.cta-btn {\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 700;\n  border-radius: 30px;\n  color: var(--white);\n  width: 100%;\n  white-space: nowrap;\n}\n\n.sidebar-top-cta-wrap {\n  padding: 10px 5px 0;\n}\n\n.advertisement-card {\n  height: 180px;\n  border-radius: 18px;\n  overflow: hidden;\n}\n\n.advertisement-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.theme-label span,\n.sidebar-ad-section p {\n  font-size: 10px;\n  color: var(--gray);\n  line-height: 16px;\n  font-weight: 400;\n  display: block;\n}\n\n.sidebar-ad-section {\n  padding: 20px;\n}\n\n// mobile bottom bar css start\n.Mobile-bottom-bar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4.25rem;\n  background-color: var(--theme-dark);\n  z-index: 999;\n  box-shadow: 0px 0px 4px var(--blackOpacity50);\n\n  .list-inline {\n    --bs-gutter-y: 0;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: calc(var(--bs-gutter-y) * -1);\n\n    .list-inline-item {\n      flex: 1 0 0%;\n      margin-right: 0 !important;\n      padding: 0.625rem 0.25rem;\n      text-align: center;\n\n      span {\n        font-size: 12px;\n        color: var(--white);\n        white-space: nowrap;\n      }\n\n      &.active {\n        img {\n          filter: brightness(0) saturate(100%) invert(21%) sepia(74%) saturate(2846%) hue-rotate(177deg) brightness(94%) contrast(99%);\n        }\n\n        span {\n          color: var(--aquaBlue);\n        }\n      }\n    }\n  }\n\n  & button {\n    width: 3rem;\n    min-width: 3rem;\n    height: 3rem;\n    background: var(--sidebarTooltip);\n    position: relative;\n    padding: 0.25rem;\n\n    & svg {\n      filter: brightness(10);\n      width: 1.2rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
